const removeById = (id, array) => {
  if (!Array.isArray(array)) {
    return undefined;
  }

  // TODO: move into predicates utilities as an id => item => result type of function
  const predicate = (item) => item.id !== id;
  return array.filter(predicate);
};

// noinspection JSUnusedGlobalSymbols
export default removeById;
